$(document).ready(function() {

    let body = $("body");
    let main = $("#wrapper-main");
    let stickynav = $(".stickynav");
    let mainNav = $(".navigation-primary");
    let desktopCont = $(".navigation-utility");
    let cookieEl = $(".cookie-identifier.fixed");
    let cookieHeight = (cookieEl.length) ? $(cookieEl)[0].offsetHeight : 0;
    let hideAnimation = "navigation-utility__userRole--hide";
    let addAnimation = "navigation-utility__userRole--active";

    if (!desktopCont.find(".navigation-utility__submenu").hasClass("navigation-utility__submenu--isEdit")) {
        let submenu = desktopCont.find(".js-toggle").clone();
        desktopCont.find(".navigation-utility__toggleMenu").append(submenu);
    }

    let dropdown = desktopCont.find(".navigation-utility__item--dropdown");

    function checkCookie(cookieHeight) {
        let wWidth = $(this).width();
        let paddingTop = (wWidth > 1247) ? 40 : 0;

        if (cookieEl.length) {
            $(main).animate({
                paddingTop: cookieHeight + paddingTop
            });
            desktopCont.animate({
                top: cookieHeight
            });
            mainNav.animate({
                top: cookieHeight + paddingTop
            });
        } else {
            $(body).addClass("js-no-cookie");
        }
    }

    $("#dismiss-cookie").click(function() {
        $(cookieEl).slideUp();
        checkCookie(0);
        $(body).addClass("js-no-cookie");
    });

    checkCookie(cookieHeight);

    $(window).on('resize', function() {
        cookieHeight = (cookieEl.length) ? $(cookieEl)[0].offsetHeight : 0;
        checkCookie(cookieHeight);
    });

    desktopCont.find(".js-dropdown").on("click", function() {
        let _self = $(this);
        let key = this.dataset.dropdown;

        let checkOpen = dropdown.hasClass("navigation-utility__item--active");
        let subList = desktopCont.find(".navigation-utility__toggleMenu .js-toggle");
        let space = 40 + cookieHeight;

        if(checkOpen) {
            dropdown.removeClass("navigation-utility__item--active");
            let stickynavTop = space + mainNav.innerHeight() + 20;

            stickynav.stop().animate({
                top: stickynavTop + "px"
            });
            subList.slideUp();
            main.animate({
                paddingTop: space + "px"
            }, function() {
                desktopCont.find(".navigation-utility__submenuItem--active").click();
                $(".navigation-utility__userRole").hide();
            });
            mainNav.animate({
                top: space + "px"
            });
        } else {
            let submenuContainer = desktopCont.find(".navigation-utility__toggleMenu");
            let subItem = submenuContainer.find(".js-toggle[data-toggle="+ key +"]");
            let containerHeight = submenuContainer.innerHeight() + subItem.innerHeight() + space;
            let stickynavTop = containerHeight + mainNav.innerHeight() + 20;
                      
            stickynav.stop().animate({
                top: stickynavTop + "px"
            });

            if (_self.hasClass("navigation-utility__item--active")) {
                _self.removeClass("navigation-utility__item--active");

                subItem.slideUp();
                main.animate({
                    paddingTop: space + "px"
                });
                mainNav.animate({
                    top: space + "px"
                });
            } else {
                _self.addClass("navigation-utility__item--active");

                subItem.slideDown();
                main.animate({
                    paddingTop: containerHeight + "px"
                });
                mainNav.animate({
                    top: containerHeight + "px"
                });
            }
        }
    });

    desktopCont.find(".navigation-utility__submenuItemUserRole")
    .on("mouseover", function() {
        $(this).find(".navigation-utility__userRole").show().addClass(addAnimation);
    })
    .on("mouseleave", function() {
        funcHideAnimation($(this).find(".navigation-utility__userRole"), hideAnimation);
    })
    .on("click", function(e) {
        e.stopPropagation();
    });

    desktopCont.find(".navigation-utility__submenuItem--linkHover")
    .on("mouseover", function() {
        $(this).find(".navigation-utility__dropdownLinkHover").show().addClass(addAnimation);
    })
    .on("mouseleave", function() {
        funcHideAnimation($(this).find(".navigation-utility__dropdownLinkHover"), hideAnimation);
    });

    desktopCont.find(".navigation-utility__userRoleCheck").on("click", function(e) {
        e.stopPropagation();
    });

    if (desktopCont.hasClass("navigation-utility--edit")) {
        allItemUserRole.off("hover mouseover mouseleave");
    }

    setAudience(desktopCont.find(".js-role"));
    
    let mobileCont = $(".navigation-utility__mobile");
    let mobileLinkContainer = mobileCont.find(".navigation-utility__mobileLinks");
    let mobileDropdown = mobileLinkContainer.find(".js-dropdown");

    mobileDropdown.on("click", function(e) {
        e.stopPropagation();
        let toggleContainer = $(this).find(".js-toggle");
        let toggleHeader = toggleContainer.find(".navigation-utility__submenuHeader");

        toggleContainer.fadeIn();

        toggleHeader.on("click", function(e) {
            e.stopPropagation();
            toggleContainer.fadeOut();
        });
    });

    let mobileLinkBottom = mobileCont.find(".navigation-utility__mobileBottom");
    let mobileBottomDropdown = mobileLinkBottom.find(".js-dropdown");

    mobileBottomDropdown.on("click", function(e) {
        e.stopPropagation();
        let toggleContainer = $(this).find(".js-toggle");

        $(this).toggleClass("navigation-utility__item--active");
        toggleContainer.fadeToggle();

        toggleContainer.on("click", function(e) {
            e.stopPropagation();
        });
    });

    mobileCont.find(".navigation-utility__submenuItemUserRole").on("click", function(e) {
        e.stopPropagation();
    });

    setAudience(mobileCont.find(".js-role"));

    $(".js-checkRole").on("change", function() {
        let _self = $(this);
        let parent = _self.parent();
        let btnContainer = parent.next();
        let btn = btnContainer.find("button");
        
        if (_self.is(":checked")) {
            btn.removeAttr("disabled");
        } else {
            btn.attr("disabled", true);
        }
    });

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function setAudience(elem) {
        let dropdown = elem.closest(".js-dropdown")[0];
        if (!dropdown) return false;
        let dropdownEl = elem.closest(".js-dropdown")[0].firstElementChild;
        let cookie = getCookie("InvescoUserCookieName");
        if (cookie) {
            let escapeCookie = sanitizeString(cookie);
            let userRoleEl = $(".js-role[data-role='"+ escapeCookie +"']")[0];
            let audience = userRoleEl ? userRoleEl.dataset.title : " ";
            dropdownEl.textContent = audience;
        }
    }

    function funcHideAnimation(elem, addClass) {
        elem.removeClass(addAnimation).addClass(addClass)
            .fadeOut(300, function() {
                $(this).removeClass(addClass);
            });
    }

    function sanitizeString(str) {
        let entityMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;'
        };
        return String(str).replace(/[&<>"'`=\/]/g, function (s) {
            return entityMap[s];
        });
    }
});